import React from 'react';
import { T } from '@transifex/react';
import { TNotificationMode } from '../store';
import { notificationModeContact2Map } from './consts';

export const getAlertConfig = (
  hasNoSubscriptions: boolean,
  allSubscribed: boolean,
  mode: TNotificationMode
) => {
  const media = notificationModeContact2Map[mode];

  if (hasNoSubscriptions) {
    return {
      type: 'warning' as const,
      message: <T _str="You have no active subscriptions" />,
      description: (
        <T
          _str="Use the Subscribe buttons below to get started. You will receive text messages on your {media} for container pickups."
          media={media}
        />
      ),
    };
  }

  if (allSubscribed) {
    return {
      type: 'success' as const,
      message: <T _str="You're subscribed to all containers" />,
      description: (
        <T
          _str="You will receive text messages on your {media} for container pickups. Changes take effect immediately after saving."
          media={media}
        />
      ),
    };
  }

  return {
    type: 'info' as const,
    message: <T _str="You have active subscriptions" />,
    description: (
      <T
        _str="You will receive text messages on your {media} for container pickups. Changes take effect immediately after saving."
        media={media}
      />
    ),
  };
};
